/**
 * 撤稿指令管理
 * Bai.Zhiming
 * 2019-7-2
 */
angular.module("withdrawalMgtRouterModule", [])
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.state("front.editctr.iWo.withdrawalmgt", {
            url: "/withdrawalmgt",
            views: {
                "main@front.editctr": {
                    templateUrl: "./editingCenter/iWo/withdrawalMgt/withdrawalMgt_tpl.html",
                    controller: "withdrawalMgtCtrl"
                }
            }
        });
    }]);